import { z as zod } from "zod";
import { MediaRefSchema } from "@/app/features/shared/__to_be_integrated/types/forms/MediaRefSchema";
import { LinkSchema } from "@/app/features/shared/__to_be_integrated/types/forms/LinkSchema";
import { TeamMemberSchema } from "@/app/features/sites/admin/team/types/TeamMember.schema";
import {
    Enum_Componentgeneraldetail_Viewvariant,
    Enum_Relatedinfo_Viewvariant
} from "@/app/lib/generated/graphql-types";
import { RELATED_INFO_REF_SCHEMA_TAG } from "@/app/features/shared/__to_be_integrated/types/forms/RelatedInfoRefSchema";
import { LINKED_SCHEMA_TAG } from "@/app/features/shared/__to_be_integrated/types/forms/LinkedRefSchema";

export const DetailSchema = zod.object({
    id: zod.string(),
    viewVariant: zod.nativeEnum(Enum_Componentgeneraldetail_Viewvariant),
    title: zod.string().nullish(),
    subtitle: zod.string().nullish(),
    description: zod.string().nullish(),
    links: zod.array(LinkSchema).nullish(),
    documents: zod.array(zod.object({
        id: zod.string().nullish(),
        media: MediaRefSchema.nullish(),
        order: zod.number(),
    })).nullish(),
    image: MediaRefSchema.nullish(),
    imagePosition: zod.string().nullish(),
    splitMax: zod.number().nullish(),
    splitInitial: zod.number().nullish(),
});

export const ShowroomSchema = zod.object({
    documentId: zod.string(),
    title: zod.string(),
    subtitle: zod.string().nullish(),
    description: zod.string().nullish(),
    images: zod.array(MediaRefSchema),
}).describe(LINKED_SCHEMA_TAG);

export const RelatedInfoSchema = zod.object({
    documentId: zod.string(),
    hasChanges: zod.boolean().nullish(),
    published: zod.boolean().nullish(),
    title: zod.string().nullish(),
    subtitle: zod.string().nullish(),
    description: zod.string().nullish(),
    colSpan: zod.number().nullish(),
    image: MediaRefSchema.nullish(),
    imagePosition: zod.string().nullish(),
    imageScale:  zod.number().nullish(),
    links: zod.array(LinkSchema),
    showDivider: zod.boolean(),
    showGeneralContact: zod.boolean(),
    showLinksTitle: zod.boolean(),
    sideImage: MediaRefSchema.nullish(),
    teamMember: TeamMemberSchema.nullish(),
    viewVariant: zod.nativeEnum(Enum_Relatedinfo_Viewvariant)
}).describe(RELATED_INFO_REF_SCHEMA_TAG);
